import React from 'react';
import { Label, Table } from 'semantic-ui-react';

const CRMCategoryCell = ({ rowValues, entryRecord, index }) => {
  let crmCategories = [];
  const rowValue = rowValues[entryRecord.key];
  if (rowValue !== 'null' && typeof rowValue !== 'undefined') {
    rowValue.split(',').forEach(category => {
      crmCategories.push(
        <Label basic style={{ fontWeight: 'normal' }} key={rowValues.ID + index + category}>
          {category}
        </Label>
      );
    });
  }

  return (
    <Table.Cell key={rowValues.ID + index} className="tableCell tableCellReducedPadding2">
      {rowValue !== 'null' && crmCategories}
    </Table.Cell>
  );
};

export default CRMCategoryCell;
